module.exports = __webpack_public_path__ + "img/expovina-primavera_02.8cd1707b.jpg";